import { ORIGINAL_POINTER_POLICY_MANIFEST } from "../data/generated/original-pointer-policy";

export const ORIGINAL_POINTER_POLICY_RUNTIME_CONSUMPTION = {
  manifest: "docs/original-pointer-policy.json",
  generatedManifestModule: "web/src/data/generated/original-pointer-policy.ts",
  consumesPointerPolicy: true,
  sourceBackedStatus: ORIGINAL_POINTER_POLICY_MANIFEST.status,
  sourceBackedCriteria: {
    sourceBackedClickWaitPrimitivesDecoded:
      ORIGINAL_POINTER_POLICY_MANIFEST.criteria.sourceBackedClickWaitPrimitivesDecoded,
    sourceBackedPointerStatementIds: ORIGINAL_POINTER_POLICY_MANIFEST.criteria.sourceBackedPointerStatementIds,
    originalMouseMovementSemanticsScopedOutForModernAdapter:
      ORIGINAL_POINTER_POLICY_MANIFEST.criteria.originalMouseMovementSemanticsScopedOutForModernAdapter,
    modernAdapterPolicyDecoded: ORIGINAL_POINTER_POLICY_MANIFEST.criteria.modernAdapterPolicyDecoded,
    usesManifestBackedMovementAndCollision:
      ORIGINAL_POINTER_POLICY_MANIFEST.criteria.usesManifestBackedMovementAndCollision,
    pathInterruptionRulesParityBacked:
      ORIGINAL_POINTER_POLICY_MANIFEST.criteria.pathInterruptionRulesParityBacked,
    frmFullDecodeNotRequiredForPointerGate:
      ORIGINAL_POINTER_POLICY_MANIFEST.criteria.frmFullDecodeNotRequiredForPointerGate
  }
} as const;

export function originalPointerPolicyRuntimeConsumesPointerPolicy(): boolean {
  return ORIGINAL_POINTER_POLICY_RUNTIME_CONSUMPTION.consumesPointerPolicy;
}

export function originalPointerPathRuntimeCanQueue(
  mode: string,
  messageCount: number,
  battleActive: boolean
): boolean {
  void messageCount;
  return mode === "map" && !battleActive;
}

export function originalPointerPathRuntimeShouldInterrupt(
  mode: string,
  messageCount: number,
  battleActive: boolean
): boolean {
  return !originalPointerPathRuntimeCanQueue(mode, messageCount, battleActive);
}

export function originalPointerPathStepIntervalMs(): number {
  return 150;
}
